<ul>
  @for (change of changeText; track change) {
    <li>{{ change.text }}</li>
  }
</ul>